import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Icon,
  List,
  ListIcon,
  ListItem,
  Text,
} from '@chakra-ui/react';

import { CheckCircleIcon } from '@chakra-ui/icons';
import { Link } from 'gatsby';
import React from 'react';

const ReasonForSelling = () => (
  <Box
    backgroundColor="gray.100"
    py={20}
  >
    <Container maxW="container.xl">
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Box
          p={{ md: 4 }}
          mb={4}
          flexGrow="1"
          flexBasis={{ base: '100%', md: '50%' }}
        >
          <Heading size="3xl">
            We Can Buy Your Home
            {' '}
            <span className="highlight">
              No Matter What Your Reasons Are For Selling!
            </span>
          </Heading>
        </Box>
        <Box
          flexGrow="1"
          flexBasis={{ base: '100%', md: '50%' }}
          p={{ md: 4 }}
          pt={4}
        >
          <List
            fontSize="2xl"
            spacing={3}
          >
            <ListItem>
              <ListIcon
                as={CheckCircleIcon}
                color="green.200"
              />
              Avoiding Foreclosure
            </ListItem>
            <ListItem>
              <ListIcon
                as={CheckCircleIcon}
                color="green.200"
              />
              Mold, Water, Fire Damage
            </ListItem>
            <ListItem>
              <ListIcon
                as={CheckCircleIcon}
                color="green.200"
              />
              Selling You House Without Listing it
            </ListItem>
            <ListItem>
              <ListIcon
                as={CheckCircleIcon}
                color="green.200"
              />
              Sell Old House To Buy New Place
            </ListItem>
            <ListItem>
              <ListIcon
                as={CheckCircleIcon}
                color="green.200"
              />
              Elderly In Need Of Assisted Living
            </ListItem>
          </List>
          <Link to="/get-offer">
            <Button
              mt={10}
              variant="btnCTA"
              size="lg"
              isLoading={false}
              type="submit"
            >
              Get Your Free offer
            </Button>
          </Link>
        </Box>
      </Box>
    </Container>
  </Box>
);

export default ReasonForSelling;
